import { View } from '@react-pdf/renderer';
import PDFWrapper, { DukeFooterLogo, Message, Row, SignatureSection } from '../PdfLayout';
import EducationVerificationProps from './types';

function EducationVerification({ data }: { data: EducationVerificationProps }): React.ReactElement {
  const labels = {
    name: 'Name of Student:',
    USI: 'USI:',
    dob: 'Date of Birth:',
    course: 'Course:',
    startDate: 'Commencement Date:',
    studySchedule: 'Study Schedule:',
    semesters: 'Number of Semesters:',
    semester: 'Semester:',
    semesterStartDate: 'Semester Start Date:',
    semesterEndDate: 'Semester End Date:',
    weeklyHours: 'Weekly Hours:',
    passed: 'Has the student passed all available coursework for this semester?',
  };

  return (
    <PDFWrapper title="Education Verification">
      <View
        style={{
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          padding: '16px',
        }}
      >
        {Object.keys(labels).map((key) => (
          <Row key={key} label={labels[key]} value={data[key]} />
        ))}
        <Message
          text={
            data.semester === 1
              ? `Class contact hours include time spent attending online tutorials and completing online quizzes that are part of the course requirements. I confirm that the details on this document are true and correct and that the participant has successfully passed (not only attended) the course work requirements for the semester.`
              : `Class contact hours include time spent attending online tutorials and completing online quizzes that are part of the course requirements. I confirm that the details on this document are true and correct and that the participant has successfully passed (not only attended) the course work requirements and will be issued a certificate.`
          }
        />

        <View style={{ marginTop: '32px' }}>
          <SignatureSection signatureDate={data.signatureDate} />
        </View>

        <View style={{ marginTop: 20 }}>
          <DukeFooterLogo />
        </View>
      </View>
    </PDFWrapper>
  );
}

export default EducationVerification;
